import { Box } from "@mui/material";
import ArchivedOverlay from "@/modules/common/components/ui-kit/archived-overlay";
import AssignedUserField from "@/modules/lead-page/new/components/sidebar/fields/assigned-user-field";

export default function LeadAssignedUser({
  isArchived,
}: {
  isArchived?: boolean;
}) {
  return (
    <ArchivedOverlay isArchived={isArchived} sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <AssignedUserField />
      </Box>
    </ArchivedOverlay>
  );
}
